// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "/* Global CSS styles applied to the whole app */\n\nbody {\n  margin: 0;\n  font-family: sans-serif;\n}\n", ""]);
// Exports
module.exports = exports;
